import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRollsRoyceComponent } from './simple-icons-rolls-royce.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRollsRoyceComponent ],
    exports:      [ SimpleIconsRollsRoyceComponent ],
    bootstrap:    []
})
export class SimpleIconsRollsRoyceModule {}
